import { GiftCardType } from '../types/types';

export const getUseGiftCardUrl = (type: GiftCardType, slug: string = null, subscriberResourceId: number = 0) => {
  const searchquery = type === 'universal' ? 'gc=1' : 'wellness=1';
  if (!slug) return `/vad/var?${searchquery}`;
  return `/places/${slug}${subscriberResourceId ? `?sr=${subscriberResourceId}` : ''}`;
};
